import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Contact from "./components/Contact";



const AppRoutes = [
  {
    path: '/',
    element: <Home />
  },
  {
    path: '/about',
    element: <About />
  },
  {
   path: '/services',
    element: <Services />
  },
  {
   path: '/contact',
    element: <Contact />
  },
];

export default AppRoutes;
